import * as api from "../API/index";

//forgot password
export const forgetPassword = async (emailData) => {
  try {
    const res = await api.user_forgot_password(emailData);
    return res.data;
  } catch (err) {
    return err?.response?.data;
  }
};
